const TRIM_NO_TAGS_FORMAT = "<[a-zA-Z0-9][^/]*?>.*?</[a-zA-Z0-9]*>|<[a-zA-Z0-9].*?/>";

export function sanitizeString(value: string): string {
    return value === "" ? value : removeTags(value.trim());
}

function removeTags(string: string): string {
    return string.replace(new RegExp(TRIM_NO_TAGS_FORMAT, "gi"), "");
}
